import './polyfills/nodeListForEach';
import ShopifySectionsManager from 'shopify-sections-manager';
import 'intersection-observer';
import CurrencyConverter from 'shopify-currency-converter';
import rimg from 'rimg-shopify';
import PxsMap from 'pxs-map';
import themeUtils from './themeUtils';
import './helpers/polyfill-nodelist-foreach';
// Flickity iOS fix
import flickityTouchFix from './helpers/FlickityTouchFix';
// Templates
import TemplateAccount from './templates/TemplateAccount';
import TemplateLogin from './templates/TemplateLogin';
import TemplateGiftCard from './templates/TemplateGiftCard';
// Components
import RTE from './components/RTE';
import Select from './components/Select';
// Dynamic Sections
import DynamicBlog from './sections/DynamicBlog';
import DynamicCollectionsList from './sections/DynamicCollectionsList';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicMasonry from './sections/DynamicMasonry';
import DynamicPromotion from './sections/DynamicPromotion';
import DynamicSocialWidgets from './sections/DynamicSocialWidgets';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTestimonials from './sections/DynamicTestimonials';
import DynamicVideoWithTextOverlay from './sections/DynamicVideoWithTextOverlay';
// Static sections
import StaticArticle from './sections/StaticArticle';
import StaticHeader from './sections/StaticHeader';
import StaticCollection from './sections/StaticCollection';
import StaticCart from './sections/StaticCart';
import StaticBlog from './sections/StaticBlog';
import StaticBlogMasonry from './sections/StaticBlogMasonry';
import StaticCollectionsList from './sections/StaticCollectionsList';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import ProductSection from './sections/ProductSection';

class ThemeView {
  constructor() {
    this.el = document.body;
    this.$el = $(this.el);

    const sections = new ShopifySectionsManager();
    // Dynamic Sections
    sections.register('dynamic-blog', section => new DynamicBlog(section));
    sections.register('dynamic-collections-list', section => new DynamicCollectionsList(section));
    sections.register('dynamic-featured-collection', section => new DynamicFeaturedCollection(section));
    sections.register('dynamic-masonry', section => new DynamicMasonry(section));
    sections.register('dynamic-promotion', section => new DynamicPromotion(section));
    sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
    sections.register('dynamic-social-widgets', section => new DynamicSocialWidgets(section));
    sections.register('dynamic-testimonials', section => new DynamicTestimonials(section));
    sections.register('dynamic-video-with-text-overlay', section => new DynamicVideoWithTextOverlay(section));
    sections.register('product', section => new ProductSection(section));
    sections.register('pxs-map', section => new PxsMap(section));
    // Static Sections
    sections.register('static-article', section => new StaticArticle(section));
    sections.register('static-collection', section => new StaticCollection(section));
    sections.register('static-collections-list', section => new StaticCollectionsList(section));
    sections.register('static-header', section => new StaticHeader(section));
    sections.register('static-cart', section => new StaticCart(section));
    sections.register('static-blog', section => new StaticBlog(section));
    sections.register('static-blog-masonry', section => new StaticBlogMasonry(section));
    sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));

    flickityTouchFix();

    $('.contact-form').on('submit', () => this.spamCheck);

    $.when($.ready).then(() => $(document.documentElement).removeClass('loading'));

    const body = $(document.body);
    // Set up conditionals
    this.isHome = body.hasClass('template-index');
    this.isProduct = body.hasClass('template-product');
    this.isPage = body.hasClass('template-page');
    this.isAccount = body.attr('class').indexOf('-customers-') > 0;
    this.isSearch = body.hasClass('template-search');
    this.isPasswordPage = body.hasClass('template-password');
    this.isGiftCardPage = body.hasClass('gift-card-template');
    this.hasCurrencySwitcher = $('.currency-switcher').length > 0;

    if (this.hasCurrencySwitcher) {
      this.currencySwitcherSelector = '[data-currency-converter]';
      this.$switcher = $(this.currencySwitcherSelector);
      this.priceSelector = '.money';
      this.currencySwitcher();
    }

    this.eventBinding();

    if (this.isAccount) { new TemplateAccount({ el: this.$el }); }
    if (this.isPasswordPage) { new TemplateLogin(); }
    if (this.isGiftCardPage) { new TemplateGiftCard(); }

    if (!this.isProduct) {
      const rte = $('.rte');
      for (let i = 0; i < rte.length; i++) { new RTE({ el: rte[i] }); }
      const select = $('select');
      for (let i = 0; i < select.length; i++) { new Select({ el: select[i] }); }
    }

    // LT-IE10: Fix placeholders
    if ($('html').hasClass('lt-ie10')) { return this.inputPlaceholderFix(); }
  }

  currencySwitcher() {
    const currencyData = JSON.parse($('[data-currency-data]').html());
    CurrencyConverter.init({
      switcherSelector: this.currencySwitcherSelector,
      priceSelector: this.priceSelector,
      shopCurrency: currencyData.shopCurrency,
      defaultCurrency: currencyData.defaultCurrency,
      displayFormat: currencyData.displayFormat,
      moneyFormat: currencyData.moneyFormat,
      moneyFormatNoCurrency: currencyData.moneyFormatNoCurrency,
      moneyFormatCurrency: currencyData.moneyFormatCurrency,
    });

    this.$switcher.trigger('updateCurrency');
    $('.selected-currency').text(this.$switcher.val());
    this.moveCurrencyConverter();
  }

  moveCurrencyConverter() {
    const $currencyWrapper = $('.currency-wrapper');
    if (themeUtils.isLessThanLarge()) {
      $currencyWrapper
        .detach()
        .insertAfter('.navigation-menu')
        .addClass('mobile-currency-wrapper');
    } else {
      $currencyWrapper
        .detach()
        .removeClass('mobile-currency-wrapper')
        .appendTo('[data-header-currency-converter]');
    }
  }

  eventBinding() {
    if (this.$switcher) {
      this.$switcher.on('change', (event) => {
        CurrencyConverter.setCurrency(event.currentTarget.value);
        $('.selected-currency').text(this.$switcher.val());
      });
    }

    $(window).on('resize.currency', themeUtils.debounce(this.moveCurrencyConverter, 100));
  }

  inputPlaceholderFix() {
    const placeholders = $('[placeholder]');

    $.each(placeholders, (index, input) => {
      input = $(input);
      if (!(input.val().length > 0)) {
        const text = input.attr('placeholder');
        input.attr('value', text);
        input.data('original-text', text);
      }
    });

    placeholders.focus(() => {
      const input = $(this);
      if (input.val() === input.data('original-text')) {
        return input.val('');
      }
    });

    return placeholders.blur(() => {
      const input = $(this);
      if (input.val().length === 0) {
        return input.val(input.data('original-text'));
      }
    });
  }

  spamCheck(e) {
    if (this.$(e.target).find('.comment-check').val().length > 0) {
      return e.preventDefault();
    }
  }
}

rimg.init();
window.theme = new ThemeView();
